angular.module('rightPaneModule')
    .directive('dblLessonGroupActivity', ['$compile', 'dblLessonService', '$modal', '$filter',
        function($compile, dblLessonService, $modal, $filter) {
        // This directive renders the core html of the lesson group activity cards.

        var SUBHEADER_HTML = '<span>{{ getLessonStatusText() }}</span>' +
            '<span class="understanding-text">{{ getUnderstandingText() | translate }}</span>';

        return {
            restrict: 'E',
            templateUrl: '/resources/right-pane/components/activity-feed/dbl-lesson-activity.directive.html',
            scope: {
                dblActivity: '=',
                dblShowStudentName: '=',
                dblUseUxEaseOfUse: '='
            },
            link: function(scope, element) {

                scope.oldTemplateUrl = '/resources/right-pane/components/activity-feed/old-activity-templates/dbl-lesson-activity.directive.html';

                scope.$watch('dblActivity', function (newVal) {
                    if (!newVal) {
                        return;
                    }

                    var subheaderContent = $compile(SUBHEADER_HTML)(scope);

                    element
                        .find('.activity-header-text-2')
                        .empty()
                        .append(subheaderContent);
                });

                scope.getActivityBadgeImage = function () {
                    var imageBase = 'resources/images/';
                    var fileName;

                    if (scope.dblActivity.isLessonGroupCompletedActivity()) {
                        fileName = 'complete.png';
                    } else if (scope.dblActivity.needsAttention || scope.dblActivity.isLessonGroupStrugglingActivity()) {
                        fileName = 'alert.png';
                    } else {
                        return;
                    }

                    return imageBase + fileName;
                };

                scope.getDemoLessonSlotName = function () {
                    return scope.dblActivity.demoLessonName;
                };

                scope.getDemoLink = function () {
                    return dblLessonService.getDemoLink(scope.dblActivity.demoLessonName);
                };

                scope.getHeaderText = function () {
                    if (!scope.dblActivity.dblStandard) {
                        return '';
                    }

                    var header = scope.dblActivity.dblStandard.short_description;
                    return $filter('translate')('curriculumData.' + header, { defaultValue: header });
                };

                scope.getLessonImage = function () {
                    if (!scope.dblActivity.dblStandard) {
                        return '';
                    }

                    return dblLessonService.getImageForDblStandard(scope.dblActivity.dblStandard.name);
                };

                scope.getLessonStatusText = function () {
                    if (scope.dblActivity.isLessonGroupCompletedActivity()) {
                        return $filter('translate')('standards.lessonGroupCompletedWith');
                    } else if (scope.dblActivity.isLessonGroupStrugglingActivity()) {
                        return 'Student is ';
                    } else {
                        return '';
                    }
                };

                scope.getStatusBadgeText = function () {
                    return '';
                };

                scope.getUnderstandingText = function () {
                    if (scope.dblActivity.isLessonGroupInProgressActivity() && scope.dblActivity.needsAttention) {
                        return $filter('translate')('standards.needsAttentionOnLessonInGroup');
                    } else if (scope.dblActivity.isLessonGroupCompletedActivity()) {
                        return $filter('translate')(dblLessonService.LESSON_UNDERSTANDING.YES);
                    } else if (scope.dblActivity.isLessonGroupStrugglingActivity()) {
                        if (isFinite(scope.dblActivity.strugglingGroupFailedLessonsCount) &&
                            isFinite(scope.dblActivity.strugglingGroupTestedLessonsCount)) {

                            return 'Unsuccessful with ' +
                                scope.dblActivity.strugglingGroupFailedLessonsCount +
                                ' out of past ' +
                                scope.dblActivity.strugglingGroupTestedLessonsCount +
                                ' Lessons';
                        } else {
                            return 'Struggling in Recent Lessons';
                        }

                    } else {
                        return '';
                    }
                };

                scope.getUnderstandingClass = function () {
                    if (scope.dblActivity.isLessonGroupCompletedActivity()) {
                        return 'activity-tone-good';
                    } else if (scope.dblActivity.isLessonGroupStrugglingActivity() || scope.dblActivity.needsAttention) {
                        return 'activity-tone-warn';
                    }
                };

                scope.openMilestoneCompletedLetterModal = function () {
                    var modal = $modal.open({
                        templateUrl: 'resources/core/partials/milestone-completed-letter-modal.html',
                        windowClass: 'milestone-completed-letter-modal',
                        controller: 'MilestoneCompletedLetterModalController',
                        resolve: {
                            dblActivity: function () {
                                return scope.dblActivity;
                            }
                        }
                    });
                };
            }
        };
    }]);
